<template>
<div> 
  <div> 
    <button @click="switchTab1"> Number1</button>
    <button @click="switchTab2"> Number2</button>
  </div>
  <div class="tab_display" v-if="display===1||display==0">
    <tab-child-one>{{tabText1}}</tab-child-one>
  </div>
  <div class="tab_display" v-if="display===2">
    <tab-child-two>{{tabText2}}</tab-child-two>
  </div>
</div>

</template>

<script>
import tabChildOne from './tabChild1'
import tabChildTwo from './tabChild2'
export default {
  components: {
    tabChildOne,
    tabChildTwo
  },
  data(){
    return {
      display:0,
      tabText1:11111111111+'tab',
      tabText2:22222222222+'tab'
    }
  },
  methods:{
    switchTab1: function(){
      return this.display=1
    },
    switchTab2:function(){
      return this.display=2
    }
  },
  created:{

  }
}
</script>

<style scoped>
.tab_display{
  display :block;
}
.tab_hide{
  display: none;
}

</style>
